module.exports = __webpack_public_path__ + "static/media/darkRider.4a525e8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/lib/monsterImages/bosses/darkRider.jpg
// module id = 141
// module chunks = 0